import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.prompt');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-prompt',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.prompt/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminPromptComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public tab: string = 'prompt';
    public prompts: any[] = [];
    public categories: any[] = [];
    public filterCategory: string = '';
    public llmConfig: any = {};

    // 편집 상태
    public editing: any = null;
    public isNew: boolean = false;

    // 미리보기
    public previewContext: string = '{\n  "patient_name": "홍길동",\n  "patient_age": "45",\n  "chief_complaint": "요통",\n  "visit_date": "2026-04-01"\n}';
    public previewResult: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.prompts = data.prompts || [];
            this.categories = data.categories || [];
            this.llmConfig = data.llm_config || {};
            this.setLlmDefaults();
        }
        await this.service.render();
    }

    private setLlmDefaults() {
        const defaults: any = {
            llm_provider: 'gemini',
            gemini_model: 'gemini-2.5-flash',
            gemini_max_tokens: '8192',
            anthropic_model: 'claude-sonnet-4-20250514',
            anthropic_max_tokens: '4096',
            openai_model: 'gpt-4o',
            openai_max_tokens: '4096',
            local_base_url: 'http://localhost:11434/v1',
            local_model: 'llama3',
            llm_temperature: '0.3',
            llm_streaming: 'true',
            daily_token_limit: '500000'
        };
        for (const [key, val] of Object.entries(defaults)) {
            if (!this.llmConfig[key]) this.llmConfig[key] = val;
        }
    }

    public get filteredPrompts() {
        if (!this.filterCategory) return this.prompts;
        return this.prompts.filter((p: any) => p.category === this.filterCategory);
    }

    public getCategoryLabel(value: string) {
        const cat = this.categories.find((c: any) => c.value === value);
        return cat ? cat.label : value;
    }

    public async switchTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    // ── 프롬프트 CRUD ──
    public async newPrompt() {
        this.editing = {
            name: '',
            title: '',
            content: '',
            variables: '[]',
            category: 'system',
            description: '',
            is_active: true,
        };
        this.isNew = true;
        this.previewResult = '';
        await this.service.render();
    }

    public async editPrompt(item: any) {
        const { code, data } = await wiz.call("get_prompt", { id: item.id });
        if (code === 200) {
            this.editing = { ...data };
            this.isNew = false;
            this.previewResult = '';
        }
        await this.service.render();
    }

    public async savePrompt() {
        if (!this.editing) return;
        if (!this.editing.name || !this.editing.title) {
            await this.service.modal.show({ title: '입력 오류', message: '이름과 제목은 필수입니다.', action: '확인' });
            return;
        }
        if (this.isNew) {
            const { code } = await wiz.call("create", { data: JSON.stringify(this.editing) });
            if (code === 200) {
                await this.service.modal.show({ title: '생성 완료', message: '프롬프트가 생성되었습니다.', action: '확인' });
            }
        } else {
            const { code } = await wiz.call("update", { id: this.editing.id, data: JSON.stringify(this.editing) });
            if (code === 200) {
                await this.service.modal.show({ title: '저장 완료', message: '프롬프트가 저장되었습니다.', action: '확인' });
            }
        }
        this.editing = null;
        await this.load();
    }

    public async cancelEdit() {
        this.editing = null;
        this.previewResult = '';
        await this.service.render();
    }

    public async toggleActive(item: any) {
        await wiz.call("toggle_active", { id: item.id });
        await this.load();
    }

    public async deletePrompt(item: any) {
        const res = await this.service.modal.show({
            title: '삭제 확인',
            message: `"${item.title}" 프롬프트를 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'btn-danger'
        });
        if (res) {
            await wiz.call("delete_prompt", { id: item.id });
            await this.load();
        }
    }

    public async createNewVersion(item: any) {
        const { code } = await wiz.call("new_version", { id: item.id });
        if (code === 200) {
            await this.service.modal.show({ title: '새 버전 생성', message: '새 버전이 생성되었습니다. 이전 버전은 비활성화됩니다.', action: '확인' });
            await this.load();
        }
    }

    // ── 미리보기 ──
    public async previewPrompt() {
        if (!this.editing) return;
        const { code, data } = await wiz.call("preview", {
            content: this.editing.content,
            context: this.previewContext
        });
        if (code === 200) {
            this.previewResult = data.preview;
        }
        await this.service.render();
    }

    // ── LLM 설정 ──
    public async saveLlmConfig() {
        const { code } = await wiz.call("save_llm_config", { data: JSON.stringify(this.llmConfig) });
        if (code === 200) {
            await this.service.modal.show({ title: '저장 완료', message: 'LLM 설정이 저장되었습니다.', action: '확인' });
        }
    }
}

export default PageAdminPromptComponent;